import produce from 'immer'
import { SeccionmarketingsAction, SeccionmarketingsActionTypes } from '../actions/seccionmarketingsActions'
import { ApiStatus, ISeccionmarketingsItem } from '../models'

export const initialSeccionmarketingsState: ISeccionmarketingsState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  seccionmarketings: [],
  foundseccionmarketings: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function seccionmarketingsReducer(state: ISeccionmarketingsState = initialSeccionmarketingsState, action: SeccionmarketingsAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SeccionmarketingsActionTypes.SEARCH_SECCIONMARKETINGS:
        draft.searchString = action.searchOptions.searchString
        break
      case SeccionmarketingsActionTypes.SEARCHING_SECCIONMARKETINGS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case SeccionmarketingsActionTypes.SEARCHING_SECCIONMARKETINGS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case SeccionmarketingsActionTypes.FOUND_SECCIONMARKETINGS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundseccionmarketings.push(...action.payload.seccionmarketings.docs)
          : (draft.foundseccionmarketings = action.payload.seccionmarketings.docs)
        draft.totalDocs = action.payload.seccionmarketings.totalDocs
        break

      case SeccionmarketingsActionTypes.LOAD_SECCIONMARKETINGS:
      case SeccionmarketingsActionTypes.LOADING_SECCIONMARKETINGS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundseccionmarketings = []
        break

      case SeccionmarketingsActionTypes.LOADING_SECCIONMARKETINGS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case SeccionmarketingsActionTypes.LOADED_SECCIONMARKETINGS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.seccionmarketings = action.payload.seccionmarketings.docs
        draft.totalDocs = action.payload.seccionmarketings.totalDocs
        break

      case SeccionmarketingsActionTypes.ADD_SECCIONMARKETINGS:
      case SeccionmarketingsActionTypes.ADDING_SECCIONMARKETINGS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case SeccionmarketingsActionTypes.ADDING_SECCIONMARKETINGS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionmarketingsActionTypes.ADDED_SECCIONMARKETINGS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.seccionmarketings.push(action.payload.seccionmarketings.docs[0])
        if (draft.searchString) draft.foundseccionmarketings.push(action.payload.seccionmarketings.docs[0])
        break

      case SeccionmarketingsActionTypes.REMOVE_SECCIONMARKETING:
        draft.seccionmarketings.splice(
          draft.seccionmarketings.findIndex((seccionmarketing) => seccionmarketing._id === action.payload._id),
          1
        )
        break

      case SeccionmarketingsActionTypes.SOFT_REMOVE_SECCIONMARKETINGS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionmarketingsActionTypes.SOFT_REMOVING_SECCIONMARKETINGS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionmarketingsActionTypes.SOFT_REMOVED_SECCIONMARKETINGS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionmarketings.splice(
          draft.seccionmarketings.findIndex((seccionmarketing) => seccionmarketing._id === action.payload._id),
          1
        )
        break

      case SeccionmarketingsActionTypes.SOFT_REMOVING_SECCIONMARKETINGS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionmarketingsActionTypes.EDIT_SECCIONMARKETINGS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case SeccionmarketingsActionTypes.EDITING_SECCIONMARKETINGS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionmarketingsActionTypes.EDITED_SECCIONMARKETINGS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionmarketings[draft.seccionmarketings.findIndex((seccionmarketing) => seccionmarketing._id === action.payload._id)] = action.payload
        draft.foundseccionmarketings[draft.foundseccionmarketings.findIndex((seccionmarketing) => seccionmarketing._id === action.payload._id)] =
          action.payload
        break

      case SeccionmarketingsActionTypes.EDITING_SECCIONMARKETINGS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ISeccionmarketingsState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  seccionmarketings: ISeccionmarketingsItem[]
  foundseccionmarketings: ISeccionmarketingsItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
